/**
 * Legacy-route → V3-route translation.
 *
 * When a user hits an unauthenticated `/app/*` URL and is bounced to /login
 * with `state.from = "/app/leads"`, this table lets us send them to the V3
 * equivalent after they log in — never back to the legacy shell.
 *
 * If a legacy path isn't found here, callers should fall back to "/u6".
 */

// Keep sorted longest-first so `/app/buyers/search` matches before `/app/buyers`.
const MAP = [
  ["/app/leads/trash",         "/v3/crm/leads/trash"],
  ["/app/buyers/search",       "/v3/crm/buyers/search"],
  ["/app/buyers/trash",        "/v3/crm/buyers/trash"],
  ["/app/drip-library",        "/v3/crm/outreach/drip-library"],
  ["/app/marketing-scripts",   "/v3/crm/outreach/scripts"],
  ["/app/command-center",      "/v3/tools/command-center"],
  ["/app/paid-library",        "/v3/learn/paid-library"],

  ["/app/discover",   "/v3/crm/discover"],
  ["/app/leads",      "/v3/crm/leads"],
  ["/app/pipeline",   "/v3/crm/pipeline"],
  ["/app/buyers",     "/v3/crm/buyers"],
  ["/app/inbox",      "/v3/crm/inbox"],
  ["/app/contracts",  "/v3/crm/contracts"],
  ["/app/closings",   "/v3/crm/closings"],
  ["/app/deal-rooms", "/v3/crm/deal-rooms"],
  ["/app/marketplace","/v3/crm/marketplace"],

  ["/app/sequences",  "/v3/crm/outreach/sequences"],
  ["/app/drips",      "/v3/crm/outreach/drips"],
  ["/app/marketing",  "/v3/crm/outreach/marketing"],
  ["/app/captures",   "/v3/crm/outreach/captures"],
  ["/app/recordings", "/v3/crm/outreach/recordings"],

  ["/app/analyzer",  "/v3/tools/analyzer"],
  ["/app/portfolio", "/v3/tools/portfolio"],
  ["/app/tasks",     "/v3/tools/tasks"],
  ["/app/markets",   "/v3/markets"],
  ["/app/heatmap",   "/v3/markets/heatmap"],

  ["/app/settings",  "/v3/settings"],
  ["/app/billing",   "/v3/business/billing"],
  ["/app/team",      "/v3/business/team"],
  ["/app/workspace", "/v3/business/workspace"],
  ["/app/analytics", "/v3/business/analytics"],
  ["/app/apex",      "/v3/business/apex"],
  ["/app/funnel",    "/v3/business/funnel"],
  ["/app/upgrade",   "/v3/business/upgrade"],

  ["/app/wins",        "/v3/growth/wins"],
  ["/app/leaderboard", "/v3/growth/leaderboard"],
  ["/app/referrals",   "/v3/growth/referrals"],
  ["/app/affiliate",   "/v3/growth/affiliate"],

  ["/app/community",   "/v3/community"],

  ["/app/alerts",       "/v3/alerts"],
  ["/app/api-docs",     "/v3/api-docs"],
  ["/app/support",      "/v3/support"],
  ["/app/resources",    "/v3/learn/resources"],
  ["/app/library",      "/v3/learn/paid-library"],

  ["/app/admin", "/v3/admin/console"],
];

/**
 * Translate a legacy path to its V3 equivalent, preserving `?query#hash`.
 * Returns `/u6` for the bare `/app` root, or when nothing matches.
 * Non-legacy paths pass through unchanged.
 */
export function translateLegacyPath(path) {
  if (!path || typeof path !== "string") return "/u6";
  if (!path.startsWith("/app")) return path;
  if (path === "/app" || path === "/app/") return "/u6";
  // Split off any ?query#hash so we can match the pathname cleanly.
  const [pathname, ...rest] = path.split(/([?#])/);
  const suffix = rest.join("");
  for (const [legacy, v3] of MAP) {
    if (pathname === legacy) return v3 + suffix;
    if (pathname.startsWith(legacy + "/")) {
      return v3 + pathname.slice(legacy.length) + suffix;
    }
  }
  return "/u6"; // Unmapped `/app/*` falls back to the certified 3.0 shell (R2 cutover).
}
